import RadioButtonLabel from 'components/RadioButtonLabel';
import { Button, Modal, RadioGroup } from 'ncoded-component-library';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VacancyFillModal.styles.scss';
import { FillVacancyMethod } from 'searchality-data';

const VacancyFillModal: React.ForwardRefRenderFunction<
  ModalRef,
  {
    closeModal: () => void;
    applicantsCount?: number;
    onConfirm: (fillType?: string) => void;
  }
> = ({ closeModal, applicantsCount = 0, onConfirm }, ref) => {
  const { t } = useTranslation();

  const [fillType, setFillType] = useState('');

  const fillOptions = [
    {
      label: <RadioButtonLabel label={t('internally')} />,
      value: FillVacancyMethod.INTERNALLY,
    },
    {
      label: <RadioButtonLabel label={t('fromThePipeline')} />,
      value: FillVacancyMethod.FROM_CANDIDATE_APPLICATIONS,
      disabled: applicantsCount > 0,
    },
    {
      label: <RadioButtonLabel label={t('anotherSource')} />,
      value: FillVacancyMethod.ANOTHER_SOURCE,
    },
  ];

  const onFillTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFillType(e.target.value);
  };

  const handleContinue = async () => {
    onConfirm(fillType);
  };

  const handleOnClose = useCallback(() => {
    setFillType('');
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      ref={ref}
      title={t('vacancyFillModal.title')}
      className="vacancy-fill-modal"
      onClose={() => setFillType('')}
      footer={
        <>
          <Button variant="outline" onClick={handleOnClose}>
            {t('Cancel')}
          </Button>
          <Button onClick={handleContinue}>{t('Continue')}</Button>
        </>
      }
    >
      <p>{t('vacancyFillModal.description')}</p>
      <RadioGroup
        options={fillOptions}
        direction="row"
        onChange={onFillTypeChange}
        name={''}
        value={fillType}
      />
    </Modal>
  );
};
export default React.forwardRef(VacancyFillModal);
